import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Flex, Text, ThemeConstellation, ToggleButtonGroup } from '@zillow/constellation';

// Components
import OutputCard from './OutputCard';
import InputAndSlider from './InputAndSlider';

// Misc / Utils
import * as S from './styles';
import { useCalculator } from './hooks';

interface RoiCalculatorProps {
  itc: string;
  t: string;
  heading: string;
  subheading: string;
}
/* eslint-disable @typescript-eslint/no-unused-vars */
const RoiCalc: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<RoiCalculatorProps>>> = ({
  itc = '',
  t = '',
  heading = 'Rental Property ROI Calculator',
  subheading = 'Calculate your potential return on investment',
}: RoiCalculatorProps) => {
  /* eslint-enable */
  const { inputs, outputs, years, setYears, totalReturn } = useCalculator();

  const handleSelectYears = (value: string) => {
    setYears(value);
  };

  return (
    <ThemeProvider theme={ThemeConstellation}>
      <S.Container cardType="secondary" padding="sm">
        <Text as="h2" fontType="h4">
          {heading}
        </Text>
        <Text as="div" fontType="bodySmall" marginBottom="xs">
          {subheading}
        </Text>
        <Flex display="flex" flexWrap="wrap" justifyContent="space-between">
          {inputs.map((inputObj, i) => (
            <InputAndSlider key={i} {...inputObj} />
          ))}
        </Flex>
        {/* @ts-expect-error */}
        <ToggleButtonGroup defaultValue={years.toString()} onChange={handleSelectYears} fluid paddingY="sm">
          <S.ToggleButton value="5">5 years</S.ToggleButton>
          <S.ToggleButton value="10">10 years</S.ToggleButton>
          <S.ToggleButton value="20">20 years</S.ToggleButton>
          <S.ToggleButton value="30">30 years</S.ToggleButton>
        </ToggleButtonGroup>
        <S.OutputsContainer>
          <S.OutputsPairContainer>
            {outputs.slice(0, 2).map((outputObj, i) => (
              <OutputCard key={i} {...outputObj} />
            ))}
          </S.OutputsPairContainer>
          <S.OutputsPairContainer>
            {outputs.slice(2, 4).map((outputObj, i) => (
              <OutputCard key={i} {...outputObj} />
            ))}
          </S.OutputsPairContainer>
        </S.OutputsContainer>
        <Flex display="flex" justifyContent="flex-end" alignItems="flex-end" marginY="sm" padding="xs">
          <Text fontType="body">Total return: </Text>
          <Text fontType="h3" marginLeft="md">
            {totalReturn}
          </Text>
        </Flex>
      </S.Container>
    </ThemeProvider>
  );
};

export default RoiCalc;
